import { Dropdown } from "react-bootstrap";
import { useState, forwardRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faPrint,
  faTrash,
  faPen,
  faClone,
  faBan,
  faDollarSign,
  faEllipsisVertical,
} from "@fortawesome/free-solid-svg-icons";
import FinanceApi from "@serie3/freelancesplaceapi/api/finance/out";
import { useNavigate } from "react-router-dom";
import ErrorPopup from "../../../../../../layout/ErrorPopup";
import downloadHandler from "@serie3/freelancesplaceapi/Domain/Shared/downloadHandler";
import PDFModal from "../../../../../../layout/Popups/PDFModal";

const DotsToggle = forwardRef(({ onClick }, ref) => {
  const [hovered, setHovered] = useState(false);
  return (
    <button
      ref={ref}
      onClick={(e) => { e.preventDefault(); onClick(e); }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: hovered ? "#f0f0f0" : "transparent",
        border: "none",
        borderRadius: "8px",
        width: "32px",
        height: "32px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        color: "#757575",
        fontSize: "1rem",
        transition: "background 0.15s",
        padding: 0,
      }}
    >
      <FontAwesomeIcon icon={faEllipsisVertical} />
    </button>
  );
});

const menuStyle = {
  borderRadius: "10px",
  boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
  border: "1px solid #f0f0f0",
  padding: "6px",
  minWidth: "160px",
};

const Item = ({ icon, label, onClick, color = "#424242", iconBg, iconColor }) => (
  <Dropdown.Item
    as="div"
    onClick={onClick}
    style={{
      display: "flex", alignItems: "center", gap: "10px",
      padding: "8px 12px", borderRadius: "7px",
      fontSize: "0.88rem", fontWeight: 500,
      color, cursor: "pointer",
    }}
  >
    <span style={{
      width: "26px", height: "26px", borderRadius: "6px",
      background: iconBg, color: iconColor,
      display: "flex", alignItems: "center", justifyContent: "center",
      fontSize: "0.75rem", flexShrink: 0,
    }}>
      <FontAwesomeIcon icon={icon} />
    </span>
    {label}
  </Dropdown.Item>
);

const Divider = () => <div style={{ height: "1px", background: "#f5f5f5", margin: "4px 0" }} />;

const IndexButtons = ({
  index, bill, setShow, setBill, viewBill, editTarget,
  direction, type, deleteFunction, draft, setDraft, payed, setPayed, onMarkPaid,
}) => {
  const navigate = useNavigate();
  const [showCancelError, setShowCancelError] = useState(false);
  const [showCloneError, setShowCloneError] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);

  const clone = async () => {
    const response = await FinanceApi.clone(bill.id);
    if (response.status !== 200) setShowCloneError(true);
    else navigate("/finance/" + direction + "/" + type + "/edit/" + response.data);
  };

  const cancelBill = async () => {
    const response = await FinanceApi.cancelBill(bill.id);
    if (response.status !== 200) setShowCancelError(true);
    else navigate("/finance/out/bills/edit/" + response.data);
  };

  const markPayed = async () => {
    await FinanceApi.markPayed(bill.id, setPayed, setDraft);
    if (onMarkPaid) onMarkPaid(index);
  };

  return (
    <>
      <PDFModal showSpinner={showSpinner} setShowSpinner={setShowSpinner} />
      <ErrorPopup setShowError={setShowCancelError} showError={showCancelError}>
        ... while trying to create a cancel bill
        <br /><br />
        <strong>If you think this is a bug and we screwed up plz contact support!</strong>
      </ErrorPopup>
      <ErrorPopup setShowError={setShowCloneError} showError={showCloneError}>
        ... while trying to clone the entity
        <br /><br />
        <strong>If you think this is a bug and we screwed up plz contact support!</strong>
      </ErrorPopup>

      <Dropdown>
        <Dropdown.Toggle as={DotsToggle} />
        <Dropdown.Menu style={menuStyle}>
          <Item icon={faEye} label="View" iconBg="#e8f0fe" iconColor="#1a73e8"
            onClick={() => viewBill(setShow, setBill, bill)} />

          {(draft || direction === "in") && (
            <>
              <Divider />
              <Item icon={faPen} label="Edit" iconBg="#e8f5e9" iconColor="#2e7d32"
                onClick={() => navigate(editTarget)} />
            </>
          )}

          {!draft && (
            <>
              <Divider />
              <Item icon={faBan} label="Cancel" iconBg="#fff8e1" iconColor="#f57c00"
                onClick={cancelBill} />
            </>
          )}

          <Divider />
          <Item icon={faClone} label="Clone" iconBg="#f3e5f5" iconColor="#7b1fa2"
            onClick={clone} />

          {!payed && (
            <>
              <Divider />
              <Item icon={faDollarSign} label="Mark Paid" iconBg="#e8f5e9" iconColor="#2e7d32"
                onClick={markPayed} />
            </>
          )}

          <Divider />
          <Item icon={faPrint} label="Print" iconBg="#f5f5f5" iconColor="#616161"
            onClick={() => {
              setShowSpinner(true);
              downloadHandler("finance/print/" + bill.id, "Bill-" + bill.id + ".pdf", null, setShowSpinner);
            }} />

          {(draft || direction === "in") && (
            <>
              <Divider />
              <Item icon={faTrash} label="Delete" color="#c62828" iconBg="#ffebee" iconColor="#c62828"
                onClick={() => deleteFunction(index, FinanceApi.del(bill.id))} />
            </>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default IndexButtons;
